import { createSlice } from '@reduxjs/toolkit';
import { arrayToMap } from 'utils/arrayToMap';
import { permissionsArrayToMap } from 'utils/permissionsArrayToMap';
import { loadAllCurrentUserPermissions } from '../thunks/loadAllCurrentUserPermissions.thunk';
import { loadUserSingleProjectPermissions } from '../thunks/loadUserSingleProjectPermissions';

export const projectPermissionsSlice = createSlice({
  name: 'projectPermissions',
  initialState: {
    userProjectPermissionsByProjectId: {},
    userAdminPermissions: {},
    userBusinessPermissions: {},
    loading: false,
    isPersonalPermissionsLoaded: false,
    // The last load of the user's permissions failed: "loaded" then holds
    // nothing, which is not the same as holding no permissions.
    isPersonalPermissionsLoadFailed: false,
    // The user's permissions have loaded at least once. A reload (the project
    // view asks for one on every visit) turns "loaded" off while the earlier
    // answer is still in the store.
    isPersonalPermissionsLoadedOnce: false,
    isSystemAdmin: false,
    // The API's answer to "may this user use Nerobotti" — see
    // selectMayUseNerobotti for what it means and why it is not derived here.
    mayUseNerobotti: false,
  },
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(loadUserSingleProjectPermissions.pending, (state) => ({
        ...state,
        loading: true,
      }))
      .addCase(loadUserSingleProjectPermissions.fulfilled, (state, action) => ({
        ...state,
        loading: false,
        userProjectPermissionsByProjectId: {
          ...state.userProjectPermissionsByProjectId,
          [action.payload.projectId]: action.payload.permissions,
        },
      }))
      .addCase(loadUserSingleProjectPermissions.rejected, (state, action) => ({
        ...state,
        loading: false,
        error: action.error,
      }))
      .addCase(loadAllCurrentUserPermissions.pending, (state) => {
        state.loading = true;
        state.isPersonalPermissionsLoaded = false;
        state.isPersonalPermissionsLoadFailed = false;
      })
      .addCase(loadAllCurrentUserPermissions.fulfilled, (state, action) => {
        state.loading = false;
        state.userProjectPermissionsByProjectId = permissionsArrayToMap(
          action.payload.projectPermissions,
          'projectId'
        );
        state.userAdminPermissions = arrayToMap(
          action.payload.adminPermissions,
          'businessId'
        );
        state.userBusinessPermissions = permissionsArrayToMap(
          action.payload.businessPermissions,
          'businessId'
        );

        state.isSystemAdmin = action.payload.isSystemAdmin;
        state.mayUseNerobotti = action.payload.mayUseNerobotti === true;
        state.isPersonalPermissionsLoaded = true;
        state.isPersonalPermissionsLoadFailed = false;
        state.isPersonalPermissionsLoadedOnce = true;
      })
      .addCase(loadAllCurrentUserPermissions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error;
        state.isPersonalPermissionsLoaded = true;
        state.isPersonalPermissionsLoadFailed = true;
      });
  },
});
